<template>
  <div id="cardLabel">
    <el-form :inline="true" :model="searchForm">
      <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWord">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button size="mini" @click="onAddLabel">添加</el-button>
        <el-button size="mini" @click="onDeleteAll">批量删除</el-button>
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="labelName" label="标签名称"></el-table-column>
      <el-table-column prop="isWork" label="生效">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isWork == '1'"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="isWorkChange(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="editLabel(scope.row)"
            type="text"
            size="small">
            编辑
          </el-button>
          <el-button
            @click.native.prevent="deleteLabel(scope.row.id)"
            type="text"
            size="small">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      @close="closeLabelDialog"
      width="30%">
      <el-input v-model="labelName" placeholder="请输入1-8个字符"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeLabelDialog">取 消</el-button>
        <el-button type="primary" @click="saveLabelSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from "../utils/utils";
  export default {
    name: "card-label",
    data(){
      return{
        searchForm:{
          keyWord:""
        },
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        },
        multipleSelection:[],
        selectIds:[],
        dialogTitle:"",
        dialogVisible:false,
        labelName:"",
        action:"",
        id:null

      }
    },
    created(){
      this.getData()
    },
    methods:{
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/queryLabel",
          params:{
            keyWord:this.searchForm.keyWord,
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          callback:(res => {
            loading.close();
            this.tableData = res.data.list;
            this.pageInfo.total = res.data.total;
          }),
          catch:(err =>{
            loading.close();
          })
        })
      },
      onSearch(){
        this.getData()
      },
      onDeleteAll(){
        let id = this.selectIds.join(",")
        this.deleteLabel(id)
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        let ids = [];
        val.map(item => {
          ids.push(item.id)
        });
        this.selectIds = ids;
      },
      isWorkChange(row){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/changeLabelWork",
          params:{
            id:row.id,
            isWork:row.isWork == '1' ? '0' :'1'
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success(res.data.msg);
              this.getData();
            }else{
              this.$message.error(res.data.msg);
            }
          })
        })
      },
      editLabel(row){
        this.dialogVisible = true;
        this.action = "update";
        this.dialogTitle = "修改标签";
        this.id = row.id;
        this.labelName = row.labelName;
      },
      deleteLabel(id){
        utils.axiosMethods({
          method:"POST",
          url:"/api/cardManage/deleteLabel",
          params:{
            id:id
          },
          callback:(res =>{
            if(res.data.code == 0){
              this.$message({
                message: '恭喜你，删除成功',
                type: 'success'
              });
              this.getData();
            }
          })
        })
      },
      onAddLabel(){
        this.dialogVisible = true;
        this.action = "add";
        this.dialogTitle = "添加标签";
      },
      closeLabelDialog(){
        this.labelName = "";
        this.id = null;
        this.dialogVisible = false;
      },
      saveLabelSure(){
        let url,param;
        if(!this.labelName){
          return this.$message.error("标签名称不能为空！")
        }else if(this.labelName.length >= 8){
          return this.$message.error("标签名称为1-8个字符！")
        }
        if(this.action == "add"){
          url = "/api/cardManage/insertLabel"
          param = {
            labelName:this.labelName
          }
        }else{
          url = "/api/cardManage/updateLabel"
          param = {
            labelName:this.labelName,
            id:this.id
          }
        }
        utils.axiosMethods({
          method:"POST",
          url:url,
          params:param,
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success(res.data.msg);
              this.getData();
              this.closeLabelDialog()
            }else{
              this.$message.error(res.data.msg);
            }
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
 #cardLabel{
   .block{
     float: right;
     margin-top: 20px;
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/cardLabel.vue